import React from 'react';
import styles from './ErrorAlert.module.scss';

export type AlertVariant = 'danger' | 'warning';

export default function ErrorAlertContainer(props: {
  dismissable: boolean;
  children: React.ReactNode;
  variant?: AlertVariant;
}) {
  const variant = props.variant ?? 'danger';
  return (
    <div
      className={`alert alert-${variant} ${props.dismissable ? 'alert-dismissible' : ''} ${styles['container']} ${
        variant === 'warning' ? styles['container-warning'] : ''
      }`}
      role="alert"
    >
      {props.children}
    </div>
  );
}
